export class PurchaseProductFilterReq{
    vendorName?:string;
    invoiceNum?: string;
    company?:string;
    unitName?:string;
    unitId?:number;
    constructor( vendorName?:string, invoiceNum?: string,unitName?:string,unitId?:number,company?:string ){
        this.vendorName = vendorName;
        this.invoiceNum = invoiceNum;
        this.unitName = unitName
        this.unitId=unitId;
        this.company=company;
    }
}
